// 通用的一些名词
export default {
    'common.language.change':'зміна мови',
    'common.company.name':'DawnTron (Shenzhen) International Logistics Co., Ltd.',
    'common.company.copyright':'Copyright © 2022 DawnTron (Shenzhen) International Logistics Co., Ltd. Всі права захищені.',
    'common.company.beian.icp':'Су ICP підготовлено',
    'common.company.beian.gwa':'Су Безпека загальнодоступної мережі №',
    'common.company.address-title':'Адреса: ',
    'common.company.address-info':'промисловий парк Даланг, район Лунхуа, місто Шеньчжень, провінція Гуандун',
    'common.navigation.title.home':'Титульна сторінка',
    'common.navigation.title.about':'о нас',
    'common.navigation.title.query':'логістичний запит',
    'common.navigation.title.track':'транспортні маршрути',
    'common.navigation.title.contact':"Зв'яжіться з нами",
    'common.footer.slogan':'DawnTron (Shenzhen) International Logistics Co., Ltd. постійно шукає прориви з моменту свого заснування. Компанія сформувала унікальну систему логістичних послуг за роки накопичення та прагне надавати професійні, точні та ефективні логістичні послуги користувачам по всьому світу!',
    'common.footer.map.website-map':'Карта сайту',
    'common.footer.map.help-center':'Центр допомоги',
    'common.footer.map.help-center.question':'Загальна проблема',
    'common.footer.map.help-center.service':'обслуговування клієнтів',
    'common.footer.map.help-center.message':'Повідомлення веб-сайту',
    'common.footer.map.help-center.price':'Цінова пропозиція',
    'common.footer.map.contact-us':"Зв'яжіться з нами",
    'common.footer.map.contact-us.whatsApps':'WhatsApp: +86 18576744474',
    'common.footer.map.contact-us.skype':'Скайп: +86 18576744474',
    'common.footer.dialog.title':'Tips',
    'common.footer.dialog.content':'For any question please contact : телефон: +86 18688782252, whatsApp,skype +86 18576744474'
}